import headerTop from "@/components/HeaderTop";
import videoPlay from "@/components/VideoPlay/index";
import {
    dateFormat
} from "@/common/filters";
import {
    areaSearchTree,
    areasSearch
} from "@/http/api/area";
import {
    getUsersSearch,
    getUserPublic
} from "@/http/api/employe"
import {
    estateSettings, getTenantSettings
} from "@/http/api/system";
import {
    deepCopy
} from "@/utils/deepCopy";
import {
    validatePhone,
    validaTelandlinePhone
} from "@/utils/validate";
import {
    getEnumMetaValue
} from "@/utils/getEnumMeta";

import {
    getBasicInfo,
    updateBasicInfo,
    getCounselors,
    updateCounselors,
    getSalepoint,
    updateSalepoint,
    getCommunity,
    updateCommunity,
    getHousetypes,
    createHousetype,
    deleteHousetypes,
    updateHousetype,
    createPresellcard,
    getPresellcards,
    deletePresellcard,
    updatePresellcard,
    getMaterials,
    getVrMaterials,
    getPhotoMaterials,
    uploadMaterials,
    uploadPhotoMaterials,
    deleteMaterials,
    updateMaterialsType,
    downloadMterial,
    downloadPhotoMterial,
    uploadVr,
    updateCover,
    updateVrCover
} from "@/http/api/estate";
export default {
    components: {
        videoPlay,
        headerTop
    },
    data() {
        const validatePhoneNumber = (rule, value, callback) => {
            if (!value) {
                callback();
            } else if (!(validatePhone(value)||validaTelandlinePhone(value))) {
                callback(new Error("电话输入不正确"));
            } else {
                callback();
            }
        };
        const validateMinTotalPrice = (rule, value, callback) => {
            let max = this.basicForm.maxTotalPrice;
            if (!value) {
                callback(new Error("请输入总价最小值"));
            }
            if ((Number(max) > 0) && (Number(value) > Number(max))) {
                callback(new Error("总价最小值不能大于总价最大值"));
            } else {
                callback();
            }
        };
        const validateMaxTotalPrice = (rule, value, callback) => {
            let min = this.basicForm.minTotalPrice;
            if (!value) {
                callback(new Error("请输入总价最大值"));
            }
            if ((Number(min) > 0) && (Number(min) > Number(value))) {
                callback(new Error("总价最大值不能小于总价最小值"));
            } else {
                callback();
            }
        };
        const validateMinPrice = (rule, value, callback) => {
            let max = this.basicForm.maxPrice;
            if (!value) {
                callback(new Error("请输入均价最小值"));
            }
            if ((Number(max) > 0) && (Number(value) > Number(max))) {
                callback(new Error("均价最小值不能大于均价最大值"));
            } else {
                callback();
            }
        };
        const validateMaxPrice = (rule, value, callback) => {
            let min = this.basicForm.minPrice;
            if (!value) {
                callback(new Error("请输入均价最大值"));
            }
            if ((Number(min) > 0) && (Number(min) > Number(value))) {
                callback(new Error("均价最大值不能小于均价最小值"));
            } else {
                callback();
            }
        };
        return {
            estateId: '',
            zoom: 15,
            counselorIndex: '',
            estateTypeTitle: '',
            preSellCardTitle: '',
            photoSelectText: "批量修改类别",
            batchSetText: "请选择分类",
            activeTab: "业务信息",
            activeFollow: "全部",
            activeEducation: "幼儿园",
            activeMedical: "医院",
            activeShop: "商场",
            activeLive: "银行",
            activeRecreation: "公园",
            activePhotos: "全部",
            activeVr: "全部",
            activeFiles: "全部",
            keyword: "",
            typeImgUrl: '', // 主力户型上传图片地址
            videoUrl: "", //视频播放地址
            isFiltrateShow: false,
            isEnterAddress: false,
            isAddressError: false,
            isAllFeatures: false,
            isIndeterminate: false,
            isShowAddress: false, // 添加地址
            photosAllChecked: false,
            filesAllChecked: false,
            isUploadPhotos: false,
            isUploadFiles: false,
            checkAllFile: false,
            checkAllPhoto: false,
            isTopVisible: false,
            isEstateBasic: false,
            isFiltrateTypeShow: false,
            vrAllChecked: false,
            isLoading: false,
            isInit: {
                community: false,
                salePoint: false,
                counselors: false,
                estateBasic: false,
                housetypes: false,
                presellcards: false,
                photo: false,
                vr: false,
                accessory: false,
                isInit: true
            },
            permissions: {},
            cityName: "",
            mapData: {},
            //地图
            center: {
                lng: '',
                lat: ''
            },
            addressQuery: {
                address: "",
                latitude: "",
                longitude: "",
            },
            // 项目负责人表单
            counselorsForm: {
                managers: [{
                    userName: "",
                    userPhoneNumber: "",
                    userId: '',
                    organizationUnit: '',
                    organizationUnitId: '',
                    userType: "内部",
                    error: {
                        userName: false,
                        userPhoneNumber: false,
                    },
                },],
                assistants: [{
                    userName: "",
                    userPhoneNumber: "",
                    userId: '',
                    organizationUnit: '',
                    organizationUnitId: '',
                    userType: "内部",
                    error: {
                        userName: false,
                        userPhoneNumber: false,
                    },
                },],
                receivers: [],
                developers: [],
            },
            counselorsCopyForm: {
                managers: [{
                    userName: "",
                    userPhoneNumber: "",
                    userId: '',
                    organizationUnit: '',
                    organizationUnitId: '',
                    userType: "内部",
                    error: {
                        userName: false,
                        userPhoneNumber: false,
                    },
                },],
                assistants: [{
                    userName: "",
                    userPhoneNumber: "",
                    userId: '',
                    organizationUnit: '',
                    organizationUnitId: '',
                    userType: "内部",
                    error: {
                        userName: false,
                        userPhoneNumber: false,
                    },
                },],
                receivers: [],
                developers: [],
            },
            estateTypeForm: {
                coverUrl: '',
                file: {},
                type: 'cover',
                name: "",
                usingTypes: [],
                saleStatus: '',
                bedroomNumber: '',
                kitchenNumber: '',
                livingRoomNumber: '',
                bathroomNumber: '',
                balconyNumber: '',
                decoration: "",
                totalPrice: "",
                buildArea: "",
                indoorArea: "",
                orientationType: "",
                isMainPush: true,
                sort: '',
                pushStartTime: "",
                pushEndTime: "",
                pushRange: [],
                more: "",
            },
            preSellCardRules: {
                cardNumber: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入预售证号"
                }],
                expirationRange: [{
                    required: true,
                    trigger: "change",
                    message: "请选择预售有效期"
                }],
                bindFloor: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入绑定楼栋"
                }],
                ratifyNumber: [{
                    required: false
                }],
                ratifyArea: [{
                    required: false
                }]
            },
            estateTypeRules: {
                name: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入户型名称"
                }],
                bedroomNumber: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入样板间数目"
                }],
                livingRoomNumber: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入实景图数目"
                }],
                kitchenNumber: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入厨房数目"
                }],
                bathroomNumber: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入小区配套数目"
                }],
                balconyNumber: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入阳台数目"
                }],
                usingTypes: [{
                    required: true,
                    trigger: "change",
                    message: "请选择户型用途"
                }],
                pushRange: [{
                    required: true,
                    trigger: "change",
                    message: "请选择起止时间"
                }],
                isMainPush: [{
                    required: true,
                    trigger: "change",
                    message: "请选择是否设为主推"
                }],
                sort: [{
                    required: true,
                    trigger: "change",
                    message: "请选择主推优先级"
                }],
                coverUrl: [{
                    required: true,
                    trigger: "change",
                    message: "请上传图片"
                }],
                buildArea: [{
                    required: false
                }],
                decoration: [{
                    required: false
                }],
                saleStatus: [{
                    required: false
                }],
                indoorArea: [{
                    required: false
                }],
                totalPrice: [{
                    required: false
                }],
                orientationType: [{
                    required: false
                }],
                more: [{
                    required: false
                }]
            },
            community: {
                useRightTypes: [],
                useRightYears: [],
            },
            communityForm: {
                useRightTypes: [],
                useRightYears: [],
            },
            preSellCardForm: {
                expirationRange: []
            },
            elTop: {
                serviceHeight: 0,
                serviceItems: 0,
                estateBasic: 0,
                projectCounselors: 0,
                salePoint: 0,
                community: 0,
                estateMap: 0,
                estateType: 0,
                estatePhotos: 0,
                estateVr: 0,
                estateFile: 0,
                preSellCards: 0,
            }, // 各盒子到顶部的距离
            isEditInfo: {
                basic: false,
                counselors: false,
                salePoint: false,
                community: false,
                estateType: false,
                preSellCard: false,
                isCreateVr: false,
            }, // 显示管理模块
            basicForm: {
                city: '',
                district: "",
                street: '',
                business: "",
                address: "",
                realAddress: '',
                synopsisAddress: '',
                name: "",
                registerName: "",
                promotionName: "",
                saleStatus: '',
                minPrice: "",
                maxPrice: '',
                sellingStartTime: '',
                sellingEndTime: '',
                usingTypes: [],
                agentRange: [],
                developerName: '',
                salePhoneNumber: '',
                launchTime: '',
                serviceCompany: '',
                serviceAddress: '',
                maxTotalPrice: "",
                minTotalPrice: "",
                buildType: '',
                saleAddress: '',
                reside: '',
                deliveryTime: '',
                buildTime: '',
                servicePhoneNumber: '',
                serviceFee: '',
                locationAddress: '',
                longitude: '',
                latitude: '',
            },
            interval: null,
            estateBasic: {},
            basicRules: {
                city: [{
                    required: true,
                    trigger: "change",
                    message: "请选择城市"
                }],
                district: [{
                    required: true,
                    trigger: "change",
                    message: "请选择县/区"
                }],
                street: [{
                    required: false
                }],
                business: [{
                    required: false
                },],
                realAddress: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入详细地址",
                },],
                name: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入楼盘名称"
                }],
                promotionName: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入推广名称"
                },],
                minPrice: [{
                    required: true,
                    trigger: "blur",
                    validator: validateMinPrice,
                },],
                maxPrice: [{
                    required: true,
                    trigger: "blur",
                    validator: validateMaxPrice,
                },],
                minTotalPrice: [{
                    required: true,
                    trigger: "blur",
                    validator: validateMinTotalPrice,
                },],
                maxTotalPrice: [{
                    required: true,
                    trigger: "blur",
                    validator: validateMaxTotalPrice
                },],
                saleStatus: [{
                    required: true,
                    trigger: "change",
                    message: "请选择销售进度"
                },],
                salePhoneNumber: [{
                    required: false,
                    trigger: "blur",
                    validator: validatePhoneNumber
                },],
                servicePhoneNumber: [{
                    required: false,
                    trigger: "blur",
                    validator: validatePhoneNumber
                },],
                locationAddress: [{
                    required: true,
                    message: "请获取楼盘定位"
                }],
                reside: [{
                    required: true,
                    trigger: "change",
                    message: "请选择可住情况",
                },]
            },
            salePoint: {
                features: [],
                description: "",
                perimeter: "",
            },
            salePointForm: {
                features: [],
                description: "",
                perimeter: "",
            },
            file: {
                list: [],
                srcs: [],
            },
            files: {
                all: {
                    list: [],
                    srcs: [],
                },
                contract: {
                    list: [],
                    srcs: [],
                },
                takeLook: {
                    list: [],
                    srcs: [],
                },
                speak: {
                    list: [],
                    srcs: [],
                },
                control: {
                    list: [],
                    srcs: [],
                },
                other: {
                    list: [],
                    srcs: [],
                },
            },
            photo: [],
            photos: [],
            vrForm: {
                url: '',
                type: '',
            },
            vrRules: {
                url: [{
                    required: true,
                    trigger: "blur",
                    message: "请输入VR链接"
                }],
                type: [{
                    required: true,
                    trigger: "change",
                    message: "请选择户型"
                },],
            },
            photosType: [{
                value: "效果图",
            },
            {
                value: "实景图",
            },
            {
                value: "样板间",
            },
            {
                value: "小区配套",
            },
            {
                value: "其他",
            },
            ],
            filesType: [{
                value: "合同协议",
            },
            {
                value: "带看确认单",
            },
            {
                value: "销讲材料",
            },
            {
                value: "销控表",
            },
            {
                value: "其他",
            },
            ],
            uploadPhotoList: [],
            uploadFileList: [],
            addressList: [],
            serviceItems: [{
                name: "基本信息",
                isActive: true,
                status: true,
            },
            {
                name: "项目人员",
                isActive: false,
                status: true,
            },
            {
                name: "楼盘卖点",
                isActive: false,
                status: true,
            },
            {
                name: "小区信息",
                isActive: false,
                status: true,
            },
            {
                name: "周边信息",
                isActive: false,
                status: true,
            },
            {
                name: "主力户型",
                isActive: false,
                status: true,
            },
            {
                name: "相册信息",
                isActive: false,
                status: true,
            },
            {
                name: "VR信息",
                isActive: false,
                status: true,
            },
            {
                name: "附件信息",
                isActive: false,
                status: true,
            },
            {
                name: "预售证信息",
                isActive: false,
                status: true,
            },
            ],
            preSellCards: [],
            estateTypes: [],
            counselors: [],
            cityOptions: [],
            districtOptions: [],
            streetOptions: [],
            businessOptions: [],
            saleStatusOptions: [],
            buildTypeOptions: [],
            heatTypeOptions: [],
            communityTypeOptions: [],
            resideOptions: [],
            decorationOptions: [],
            useRightTypeOptions: [],
            useRightYearsOptions: [],
            orientationTypeOptions: [],
            sortOptions: [1, 2, 3, 4, 5],
            featuresOptions: [],
            useTypes: [],
            vrs: [],
            vr: [],
            counselorList: [],
        };
    },
    computed: {
        vrTypeOptions() {
            let arr = [];
            this.estateTypes.map(el => {
                arr.push({
                    label: el.name,
                    value: el.name + '#$%&@' + el.id
                });
            })
            arr.push({
                label: '其他',
                value: '其他'
            })
            return arr;
        },
        isVrEmpty() {
            let status = true;
            this.vr.map(el => {
                if (el.url) {
                    status = false;
                }
            })
            return status;
        },

        // 地图周边范围
        nearby() {
            return {
                center: this.center,
                radius: 1500
            };
        },
        // 相册弹窗选择分类禁止项
        isTypeDisabled() {
            if (this.uploadPhotoList.length) {
                return this.uploadPhotoList.some((el) => {
                    return el.checked == true;
                });
            }
        },
        // 附件弹窗选择分类禁止项
        isFileTypeDisabled() {
            return this.uploadFileList.some((el) => {
                return el.checked == true;
            });
        },
    },
    mounted() {
        this.initData();
        this.getEstateSettings()
    },
    methods: {
        // 内部人员搜索
        querySearch(queryString, cb) {
            if (queryString) {
                let query = `filter=${queryString}&maxResultCount=100`;
                getUsersSearch(query).then(res => {
                    if (res.code == 10200) {
                        let arr = res.result.items;
                        if (arr.length) {
                            cb(arr);
                        } else {
                            cb([{
                                name: '暂无数据'
                            }])
                        }
                    }
                })
            } else {
                if (this.counselorList.length) {
                    cb(this.counselorList);
                } else {
                    cb([{
                        name: '暂无数据'
                    }])
                }
            }
        },
        // 内部人员失焦事件
        counselorSelectBlur(v) {
            setTimeout(()=>{
                if (!v.userId || !v.userName) {
                    v.userName = '';
                    v.userId = '';
                    v.organizationUnitId = '';
                    v.organizationUnit = '';
                    v.userPhoneNumber = '';
                    this.$nextTick(() => {
                        v.error.userName = true;
                    })
                } else {
                    getUserPublic(v.userId).then(res => {
                        v.userName = res.result.name;
                    })
                    v.error.userName = false;
                }
            },500)            
        },
        // 案场接待内外部人员切换
        receiverUserTypeChange(i) {
            this.counselorsForm.receivers[i].userName = '';
            this.counselorsForm.receivers[i].userId = '';
            this.counselorsForm.receivers[i].organizationUnitId = '';
            this.counselorsForm.receivers[i].organizationUnit = '';
            this.counselorsForm.receivers[i].userPhoneNumber = '';
            this.counselorsForm.receivers[i].error.userName = false;
        },
        // 代理商对接人内外部人员切花
        developerUserTypeChange(i) {
            this.counselorsForm.developers[i].userName = '';
            this.counselorsForm.developers[i].userId = '';
            this.counselorsForm.developers[i].organizationUnitId = '';
            this.counselorsForm.developers[i].organizationUnit = '';
            this.counselorsForm.developers[i].userPhoneNumber = '';
            this.counselorsForm.developers[i].error.userName = false;
        },
        // 选择案场接待
        receiversSelect(v) {
            if (v.id) {
                this.counselorsForm.receivers[this.counselorIndex].userName = v.name;
                this.counselorsForm.receivers[this.counselorIndex].userId = v.id;
                this.counselorsForm.receivers[this.counselorIndex].organizationUnitId = v.organizationUnitId;
                this.counselorsForm.receivers[this.counselorIndex].organizationUnit = v.organizationUnit;
                this.counselorsForm.receivers[this.counselorIndex].userPhoneNumber = v.phoneNumber;
            } else {
                this.counselorsForm.receivers[this.counselorIndex].userName = '';
                this.counselorsForm.receivers[this.counselorIndex].userId = '';
                this.counselorsForm.receivers[this.counselorIndex].organizationUnitId = '';
                this.counselorsForm.receivers[this.counselorIndex].organizationUnit = '';
                this.counselorsForm.receivers[this.counselorIndex].userPhoneNumber = '';
            }
            this.counselorsForm.receivers[this.counselorIndex].error.userName = false;

            this.counselorsCopyForm = deepCopy(this.counselorsForm);
        },
        // 选择开发商/代理商对接人
        developersSelect(v) {
            if (v.id) {
                this.counselorsForm.developers[this.counselorIndex].userName = v.name;
                this.counselorsForm.developers[this.counselorIndex].userId = v.id;
                this.counselorsForm.developers[this.counselorIndex].organizationUnitId = v.organizationUnitId;
                this.counselorsForm.developers[this.counselorIndex].organizationUnit = v.organizationUnit;
                this.counselorsForm.developers[this.counselorIndex].userPhoneNumber = v.phoneNumber;
            } else {
                this.counselorsForm.developers[this.counselorIndex].userName = '';
                this.counselorsForm.developers[this.counselorIndex].userId = '';
                this.counselorsForm.developers[this.counselorIndex].organizationUnitId = '';
                this.counselorsForm.developers[this.counselorIndex].organizationUnit = '';
                this.counselorsForm.developers[this.counselorIndex].userPhoneNumber = '';
            }
            this.counselorsForm.developers[this.counselorIndex].error.userName = false;
            this.counselorsCopyForm = deepCopy(this.counselorsForm);
        },
        // 选择项目助理
        assistantSelect(v) {
            if (v.id) {
                this.counselorsForm.assistants[this.counselorIndex].userName = v.name;
                this.counselorsForm.assistants[this.counselorIndex].userId = v.id;
                this.counselorsForm.assistants[this.counselorIndex].organizationUnitId = v.organizationUnitId;
                this.counselorsForm.assistants[this.counselorIndex].userPhoneNumber = v.phoneNumber;
                this.counselorsForm.assistants[this.counselorIndex].organizationUnit = v.organizationUnit;
            } else {
                this.counselorsForm.assistants[this.counselorIndex].userName = '';
                this.counselorsForm.assistants[this.counselorIndex].userId = '';
                this.counselorsForm.assistants[this.counselorIndex].organizationUnitId = '';
                this.counselorsForm.assistants[this.counselorIndex].userPhoneNumber = '';
                this.counselorsForm.assistants[this.counselorIndex].organizationUnit = '';
            }
            this.counselorsForm.assistants[this.counselorIndex].error.userName = false;

            this.counselorsCopyForm = deepCopy(this.counselorsForm);
        },
        // 选择项目负责人
        counselorSelect(v) {
            if (v.id) {
                this.counselorsForm.managers[this.counselorIndex].userName = v.name;
                this.counselorsForm.managers[this.counselorIndex].userId = v.id;
                this.counselorsForm.managers[this.counselorIndex].organizationUnitId = v.organizationUnitId;
                this.counselorsForm.managers[this.counselorIndex].organizationUnit = v.organizationUnit;
                this.counselorsForm.managers[this.counselorIndex].userPhoneNumber = v.phoneNumber;
            } else {
                this.counselorsForm.managers[this.counselorIndex].userName = '';
                this.counselorsForm.managers[this.counselorIndex].userId = '';
                this.counselorsForm.managers[this.counselorIndex].organizationUnitId = '';
                this.counselorsForm.managers[this.counselorIndex].organizationUnit = '';
                this.counselorsForm.managers[this.counselorIndex].userPhoneNumber = '';
            }
            this.counselorsForm.managers[this.counselorIndex].error.userName = false;
            this.counselorsCopyForm = deepCopy(this.counselorsForm);
        },
        // 选择项目人员index
        selectCounselorIndex(i) {
            this.counselorIndex = i;
        },
        // 获取基础字段
        getEstateSettings() {
            this.saleStatusOptions = this.$store.getters.enumMetadata.EstateSaleStatus
            estateSettings().then(res => {
                res.result.map(item => {
                    if (item.name == 'Deer.Estate.Collection.BuildType') {
                        item.value.map(type => {
                            this.buildTypeOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.ResideType') {
                        item.value.map(type => {
                            this.resideOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.UsingType') {
                        item.value.map(type => {
                            this.useTypes.push({
                                label: type.option,
                                key: type.option,
                            })
                        })
                    } else if (item.name == 'Deer.Estate.Collection.HeatType') {
                        item.value.map(type => {
                            this.heatTypeOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.WaterType') {
                        item.value.map(type => {
                            this.communityTypeOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.DecorationType') {
                        item.value.map(type => {
                            this.decorationOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.UseRightType') {
                        item.value.map(type => {
                            this.useRightTypeOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.UseRightYearType') {
                        item.value.map(type => {
                            this.useRightYearsOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.OrientationType') {
                        item.value.map(type => {
                            this.orientationTypeOptions.push(type.option)
                        })
                    } else if (item.name == 'Deer.Estate.Collection.FeatureType') {
                        item.value.map(type => {
                            this.featuresOptions.push(type.option)
                        })
                    }
                })
            })
        },
        // 设置vr封面
        setVrCover(id) {
            updateVrCover(this.estateId, id).then(res => {
                this.getVrMaterials();
                if (res) {
                    this.$message.success({
                        message: "设置成功",
                        showClose: true,
                    });
                }
            })
        },
        // 选择街道回调
        streetChange(v) {
            let id = v.split("&$")[1];
            if (id) {
                areaSearchTree({
                    parentId: id
                }).then((res) => {
                    let arr = res.result.items;
                    this.businessOptions = [];
                    arr.map((el) => {
                        this.businessOptions.push({
                            name: el.data.name,
                            id: el.data.id,
                        });
                    });
                });
            }
        },
        // 选择行政区
        districtChange(v) {
            let id = v.split("&$")[1];
            if (id) {
                areaSearchTree({
                    parentId: id
                }).then((res) => {
                    let arr = res.result.items;
                    this.streetOptions = [];
                    arr.map((el) => {
                        this.streetOptions.push({
                            name: el.data.name,
                            id: el.data.id,
                        });
                    });
                });
            }
        },
        // 选择城市回调
        cityChange() {
            this.districtOptions = [];
            areaSearchTree({ parentName: this.basicForm.city }).then((res) => {
                let arr = res.result.items;
                this.cityName = ""
                arr.map((el) => {
                    this.districtOptions.push({
                        name: el.data.name,
                        id: el.data.id,
                    });
                });
            });
        },
        remoteMethod(val) {
            this.cityName = val;
            this.areasSearch();
        },
        // 获取城市项
        areasSearch() {
            getTenantSettings().then((res) => {
                let arr = [];
                res.result.map(el=>{
                    if (el.name=='Deer.Tenant.Collection.DomainArea') {
                        el.value.map(item=>{
                            arr.push(item.option);
                        })
                    }
                })
                this.cityOptions = deepCopy(arr);
            });
        },
        // 附件操作禁止项
        isFilesOperationDisabled() {
            let status = false;
            if (this.file.length) {
                status = this.file.some((el) => {
                    return el.checked == true;
                });
            }
            return status;
        },
        // vr操作禁止项
        isVrOperationDisabled() {
            let status = false;
            if (this.vr.length) {
                status = this.vr.some((el) => {
                    return el.checked == true;
                });
            }
            return status;
        },
        // 相册操作禁止项
        isPhotosOperationDisabled() {
            let status = false;
            if (this.photo.length) {
                status = this.photo.some((el) => {
                    return el.checked == true;
                });
            }
            return status;
        },
        // 获取素材
        getPhotos() {
            getPhotoMaterials(this.estateId).then(res => {
                //console.log();
                if (res.result.items.length) {
                    this.photos = res.result.items;
                }
                this.getPhotoItem('全部');
                this.isInit.photo = true;
            })
        },
        // 获取相册子集
        getPhotoItem(v) {
            let arr = [];
            this.photos.map(el => {
                if (el.type == v) {
                    arr = el.materials;
                }
            })
            arr.map(el => {
                el.checked = false;
            })
            this.photo = arr;
        },
        getVrMaterials() {
            getVrMaterials(this.estateId).then(res => {
                this.vrs = res.result.items;
                this.getVrItem('全部');
                this.isInit.vr = true;
            })
        },
        // 获取VR子集
        getVrItem(v) {
            let arr = [];
            this.vrs.map(el => {
                if (el.type == v) {
                    arr = el.materials;
                }
            })
            arr.map(el => {
                el.checked = false;
            })
            this.vr = arr;
        },
        getFiles() {
            getMaterials(this.estateId, 'accessory').then(res => {
                this.files = res.result.items;
                this.getFileItem('全部');
                this.isInit.accessory = true;
            })
        },
        // 获取附件子集
        getFileItem(v) {
            let arr = [];
            this.files.map(el => {
                if (el.type == v) {
                    arr = el.materials;
                }
            })
            arr.map(el => {
                el.checked = false;
            })
            this.file = arr;
        },
        // 获取预售证列表
        getPresellcards() {
            getPresellcards(this.estateId).then(res => {
                this.preSellCards = res.result.items;
                this.isInit.presellcards = true;
            })
        },
        // 获取楼盘户型列表
        getHousetypes() {
            getHousetypes(this.estateId).then(res => {
                this.estateTypes = res.result.items;
                this.isInit.housetypes = true;
            })
        },
        // 获取楼盘小区信息
        getCommunity() {
            getCommunity(this.estateId).then(res => {
                if (res.result) {
                    this.community = res.result;
                }
                this.isInit.community = true;
            })
        },
        // 获取楼盘卖点信息
        getSalepoint() {
            getSalepoint(this.estateId).then(res => {
                if (res.result) {
                    this.salePoint = res.result;
                }
                this.isInit.salePoint = true;
            })
        },
        // 获取楼盘项目人员
        getCounselors() {
            getCounselors(this.estateId).then(res => {
                let managers = [];
                if (res) {
                    managers = res.result.managers;
                }
                if (managers.length) {
                    this.counselors = [{
                        managers,
                        assistants: res.result.assistants,
                        receivers: res.result.receivers,
                        developers: res.result.developers
                    }]
                }
                this.isInit.counselors = true;
            })
            let query = 'maxResultCount=1000';
            getUsersSearch(query).then(res => {
                if (res.code == 10200) {
                    this.counselorList = res.result.items;
                }
            })
        },
        // 获取楼盘基本信息
        getBasicInfo() {
            this.estateId = this.$route.params.id;
            getBasicInfo(this.estateId).then(res => {
                if (res) {
                    this.estateBasic = res.result;
                    this.center.lng = this.estateBasic.longitude;
                    this.center.lat = this.estateBasic.latitude;
                    this.estateBasic.agentRange = this.estateBasic.sellingStartTime ? [this.estateBasic.sellingStartTime, this.estateBasic.sellingEndTime] : [];
                }
                this.isInit.estateBasic = true;
            })
        },
        // 相册弹窗分类选择回调
        photoSelect(v) {
            v.error = false;
        },
        // 删除预售证
        delPreSellCards(id) {
            this.$confirm(
                `确定将此预售证信息删除？`,
                "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }
            )
                .then(() => {
                    deletePresellcard(this.estateId, id).then(res => {
                        this.getPresellcards();
                        if (res) {
                            this.$message.success({
                                message: "删除成功",
                                showClose: true
                            });
                        }
                    })
                })
                .catch(() => {
                    //console.log("已取消");
                });
        },
        // 编辑预售证信息
        editPreSellCards(v, i) {
            v.expirationRange = [v.expirationStartTime, v.expirationEndTime];
            this.preSellCardForm = deepCopy(v);
            this.preSellCardTitle = '编辑预售证';
            this.isEditInfo.preSellCard = true;
        },
        // 提交预售证表单
        submitPreSellCard() {
            this.$refs["preSellCardForm"].validate((valid) => {
                if (valid) {
                    let data = deepCopy(this.preSellCardForm);
                    data.expirationStartTime = dateFormat(data.expirationRange[0]);
                    data.expirationEndTime = dateFormat(data.expirationRange[1]);
                    delete data.expirationRange;
                    if (this.preSellCardTitle == '编辑预售证') {
                        this.isLoading = true;
                        updatePresellcard(this.estateId, data).then(res => {
                            this.getPresellcards();
                            if (res) {
                                this.$message.success({
                                    message: "修改成功",
                                    showClose: true
                                });
                            }
                            this.isEditInfo.preSellCard = false;
                            this.isLoading = false;
                        }).catch(() => {
                            this.isLoading = false;
                        });
                    } else {
                        this.isLoading = true;
                        createPresellcard(this.estateId, data).then(res => {
                            this.getPresellcards();
                            if (res) {
                                this.$message.success({
                                    message: "添加成功",
                                    showClose: true
                                });
                            }
                            this.isEditInfo.preSellCard = false;
                            this.isLoading = false;
                        }).catch(() => {
                            this.isLoading = false;
                        });
                    }
                } else {
                    //console.log("表单验证未通过");
                    return false;
                }
            });
        },
        // 删除主力户型
        delEstateType(id) {
            if (this.permissions["Estate.Update"]) {
                this.$confirm(
                    `确定将此户型删除？`,
                    "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }
                )
                    .then(() => {
                        deleteHousetypes(this.estateId, id).then(res => {
                            this.getHousetypes();
                            if (res) {
                                this.$message.success({
                                    message: "删除成功",
                                    showClose: true
                                });
                            }
                        })
                    })
                    .catch(() => {
                        //console.log("已取消");
                    });
            } else {
                this.$message.warning({
                    message: "您暂无管理楼盘权限",
                    showClose: true,
                });
            }
        },
        // 编辑主力户型
        editEstateType(v) {
            if (this.permissions["Estate.Update"]) {
                console.log(v);
                if(v.isMainPush){
                    v.pushRange = [v.pushStartTime, v.pushEndTime];
                }else{
                    v.pushRange=[];
                    v.sort='';
                }
                this.estateTypeForm = deepCopy(v);
                this.typeImgUrl = v.coverUrl;
                this.estateTypeTitle = '编辑户型';
                this.isEditInfo.estateType = true;
            } else {
                this.$message.warning({
                    message: "您暂无管理楼盘权限",
                    showClose: true,
                });
            }
        },
        // 删除楼盘用途项
        delUseItem(v, i) {
            v.splice(i, 1);
        },
        // 获取户型附件
        getHousetypeFile(item) {
            this.estateTypeForm.file = item.file;
            this.estateTypeForm.coverUrl = true;
        },
        // 上传户型附件回调
        handleTypeImgChange(file) {
            this.typeImgUrl = URL.createObjectURL(file.raw);
        },
        // 提交主力户型表单
        submitEstateType() {
            this.$refs["estateTypeForm"].validate((valid) => {
                if (valid) {
                    let data = deepCopy(this.estateTypeForm);
                    data.pushStartTime = dateFormat(data.pushRange[0]);
                    data.pushEndTime = dateFormat(data.pushRange[1]);
                    let file = this.estateTypeForm.file;
                    delete data.pushRange;
                    delete data.file;
                    delete data.coverUrl;
                    if (!data.saleStatus) {
                        delete data.saleStatus;
                    } else {
                        data.saleStatus = getEnumMetaValue(this.$store.getters.enumMetadata, 'EstateSaleStatus', data.saleStatus);
                    }
                    if (!data.isMainPush) {
                        delete data.pushStartTime;
                        delete data.pushEndTime;
                        delete data.sort;
                    }
                    if (!data.buildArea) {
                        delete data.buildArea;
                    }
                    if (!data.indoorArea) {
                        delete data.indoorArea;
                    }
                    if (!data.decoration) {
                        delete data.decoration;
                    }
                    if (!data.totalPrice) {
                        delete data.totalPrice;
                    }
                    if (!data.orientationType) {
                        delete data.orientationType;
                    }
                    if (!data.more) {
                        delete data.more;
                    }
                    let formData = new FormData();
                    formData.append("EstateHouseType", JSON.stringify(data));
                    if (file) {
                        formData.append("File", file);
                    }
                    if (this.estateTypeTitle == '编辑户型') {
                        this.isLoading = true;
                        updateHousetype(this.estateId, formData).then(res => {
                            this.getHousetypes();
                            this.getVrMaterials();
                            this.isEditInfo.estateType = false;
                            if (res) {
                                this.$message.success({
                                    message: "修改成功",
                                    showClose: true
                                });
                            }
                            this.isLoading = false;
                        }).catch(() => {
                            this.isLoading = false;
                        })
                    } else {
                        this.isLoading = true;
                        createHousetype(this.estateId, formData).then(res => {
                            this.getHousetypes();
                            this.isEditInfo.estateType = false;
                            if (res) {
                                this.$message.success({
                                    message: "添加成功",
                                    showClose: true
                                });
                            }
                            this.isLoading = false;
                        }).catch(() => {
                            this.isLoading = false;
                        })
                    }
                } else {
                    //console.log("表单验证未通过");
                    return false;
                }
            });
        },
        // 提交小区信息表单
        submitCommunity() {
            this.communityForm.carportTotalCount = Number(this.communityForm.undergroundCarportCount) + Number(this.communityForm.overgroundCarportCount);
            let data = deepCopy(this.communityForm);
            this.isLoading = true;
            updateCommunity(this.estateId, data).then(res => {
                this.getCommunity();
                this.isEditInfo.community = false;
                if (res) {
                    this.$message.success({
                        message: res.message,
                        showClose: true
                    });
                }
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        },
        // 楼盘项目特色选择回调
        checkedFeaturesChange(val) {
            let checkedCount = val.length;
            this.isAllFeatures = checkedCount === this.featuresOptions.length;
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.featuresOptions.length;
        },
        // 楼盘项目特色全选回调
        checkAllFeaturesChange(val) {
            this.salePointForm.features = val ? this.featuresOptions : [];
            this.isIndeterminate = false;
        },
        // 提交楼盘卖点表单
        submitSalePoint() {
            let data = deepCopy(this.salePointForm);
            this.isLoading = true;

            updateSalepoint(this.estateId, data).then(res => {
                this.getSalepoint();
                if (res) {
                    this.$message.success({
                        message: res.message,
                        showClose: true
                    });
                }
                this.isEditInfo.salePoint = false;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        },
        // 编辑项目人员
        editCounselors(v) {
            if (this.permissions["Estate.Update"]) {
                v.assistants.map(el => {
                    el.error = {
                        userName: false,
                        userPhoneNumber: false,
                    }
                })
                v.developers.map(el => {
                    el.error = {
                        userName: false,
                        userPhoneNumber: false,
                    }
                })
                v.managers.map(el => {
                    el.error = {
                        userName: false,
                        userPhoneNumber: false,
                    }
                })
                v.receivers.map(el => {
                    el.error = {
                        userName: false,
                        userPhoneNumber: false,
                    }
                })
                this.counselorsForm = deepCopy(v);
                this.counselorsCopyForm = deepCopy(v);
                //console.log(this.counselorsForm, 'this.counselorsForm');
                this.isEditInfo.counselors = true;
            } else {
                this.$message.warning({
                    message: "您暂无管理楼盘权限",
                    showClose: true,
                });
            }
        },
        // 项目人员表单手机号输入框失焦事件
        counselorsPhoneBlur(v) {
            v.error.userPhoneNumber = !validatePhone(v.userPhoneNumber);
        },
        counselorsCopy(){
            this.counselorsCopyForm = deepCopy(this.counselorsForm);
        },
        // 项目人员表单输入框失焦事件
        counselorsNameBlur(v) {
            v.error.userName = !v.userName.trim();
        },
        // 项目人员弹窗关闭回调
        counselorsClose() {
            this.isEditInfo.counselors = false;
            if (this.counselors.assistants && !this.counselors.assistants.length) {
                Object.assign(
                    this.$data.counselorsForm,
                    this.$options.data().counselorsForm
                );
            }
        },
        // 添加项目人员
        addCounselors(v) {
            this.counselorsForm[v].push({
                userName: "",
                userPhoneNumber: "",
                userId: '',
                organizationUnit: '',
                organizationUnitId: '',
                userType: "内部",
                error: {
                    userName: false,
                    userPhoneNumber: false,
                },
            });
        },
        // 删除项目人员
        delCounselors(v, i) {
            this.counselorsForm[v].splice(i, 1);
            this.counselorsCopyForm = deepCopy(this.counselorsForm);
        },
        // 提交项目人员表单
        submitCounselors() {
            let arr = ["assistants", "managers", "receivers", "developers"];
            arr.map((el) => {
                this.verifyPresonForm(el);
            });
            let status =
                this.confirmPresonError("assistants") &&
                this.confirmPresonError("managers") &&
                this.confirmPresonError("receivers") &&
                this.confirmPresonError("developers");
            if (status) {
                //console.log(this.counselorsForm, "表单已通过");
                let data = deepCopy(this.counselorsCopyForm);
                data.assistants.map(el => {
                    delete el.error
                })
                data.managers.map(el => {
                    delete el.error
                })
                data.developers.map(el => {
                    delete el.error
                })
                data.receivers.map(el => {
                    delete el.error
                })

                this.isLoading = true;
                updateCounselors(this.estateId, data).then(res => {
                    this.getCounselors();
                    this.isEditInfo.counselors = false;
                    this.isLoading = false;
                    if (res) {
                        this.$message.success({
                            message: res.message,
                            showClose: true
                        });
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
            } else {
                //console.log("表单未通过");
            }
        },
        // 验证项目人员表单
        confirmPresonError(v) {
            let status = true;
            if (v == "managers" || v == "developers") {
                if (this.counselorsForm[v].length) {
                    status = this.verifyPresonForm(v);
                }
            } else {
                status = this.verifyPresonForm(v);
            }
            //console.log(status, "status");
            return status;
        },
        // 验证项目人员
        verifyPresonForm(v) {
            let status = true;
            this.counselorsForm[v].map((el) => {
                if (!el.userName.trim()) {
                    el.error.userName = true;
                    status = false;
                }
                if (!validatePhone(el.userPhoneNumber)) {
                    el.error.userPhoneNumber = true;
                    status = false;
                }
            });
            return status;
        },
        addressClose() {
            this.isShowAddress = false;
        },
        getAddress() {
            this.isEnterAddress = false;
            this.addressQuery = {
                address: "",
                latitude: "",
                longitude: "",
            };
            this.addressList = [];
            this.isShowAddress = true;
        },
        // 添加地址
        addressSubmit() {
            //console.log(this.mapData);
            if (this.mapData && this.mapData.point && this.mapData.point.lat) {
                this.addressQuery.latitude = this.mapData.point.lat;
                this.addressQuery.longitude = this.mapData.point.lng;
                this.addressQuery.address = this.mapData.address;
                this.basicForm.locationAddress = this.addressQuery.address;
                this.isAddressError = false;
                this.$nextTick(() => {
                    this.showAddressHandler();
                    this.isShowAddress = false;
                });
            } else {
                this.isAddressError = true;
            }
        },
        //显示地址
        showAddressHandler() {
            var map = new BMap.Map("showAddress"); // 创建Map实例
            var point = new BMap.Point(
                this.addressQuery.longitude,
                this.addressQuery.latitude
            );
            map.centerAndZoom(point, 15);
            var marker = new BMap.Marker(point); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
        },
        // 选择地址
        chooseAddress(res) {
            //console.log(res);
            this.addressQuery.address = res.address;
            this.mapData = res;
        },
        // 输入地址
        changeAddress() {
            this.isEnterAddress = true;
            var map = new BMap.Map("allmap"); // 创建Map实例
            map.centerAndZoom("郑州", 13);
            map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
            var myGeo = new BMap.Geocoder();
            // 将地址解析结果显示在地图上,并调整地图视野
            var that = this;

            if (that.addressQuery.address) {
                var local = new BMap.LocalSearch(map, {
                    renderOptions: {
                        map: map
                    },
                });
                local.search(this.addressQuery.address);
                //地址搜索后的回掉
                local.setSearchCompleteCallback((results) => {
                    if (local.getStatus() == BMAP_STATUS_SUCCESS) {
                        // 判断状态是否正确
                        var s = [];
                        for (var i = 0; i < results.getCurrentNumPois(); i++) {
                            s.push(results.getPoi(i));
                        }
                        this.addressList = s;
                    }
                });
            }
        },
        // 选择用途方法
        filterMethod(query, item) {
            return item.label.indexOf(query) > -1;
        },
        // 打开穿梭框
        openFiltrate() {
            this.isFiltrateShow = true;
        },
        // 关闭穿梭框回调
        usesClose() {
            this.isFiltrateShow = false;
            this.isFiltrateTypeShow = false;
        },
        // 提交基本信息表单
        submitEstateBasic() {
            this.$refs["basicForm"].validate((valid) => {
                if (valid) {
                    let data = deepCopy(this.basicForm);
                    data.sellingStartTime = data.agentRange.length ? dateFormat(data.agentRange[0]) : null;
                    data.sellingEndTime = data.agentRange.length ? dateFormat(data.agentRange[1]) : null;
                    data.launchTime = data.launchTime ? dateFormat(data.launchTime) : null;
                    data.deliveryTime = data.deliveryTime ? dateFormat(data.deliveryTime) : null;
                    data.buildTime = data.buildTime ? dateFormat(data.buildTime) : null;
                    data.longitude = this.addressQuery.longitude;
                    data.latitude = this.addressQuery.latitude;
                    data.city = data.city.split('&$')[0];
                    data.district = data.district.split('&$')[0];
                    data.street = data.street.split('&$')[0];
                    delete data.agentRange;
                    this.isLoading = true;
                    updateBasicInfo(this.estateId, data).then(res => {
                        this.getBasicInfo();
                        this.isLoading = false;
                        this.isEditInfo.basic = false;
                        if (res) {
                            this.$message.success({
                                message: res.message,
                                showClose: true,
                            });
                        }
                    }).catch(() => {
                        this.isLoading = false;
                    })
                } else {
                    //console.log("表单验证未通过");
                    return false;
                }
            });
        },
        // 弹窗关闭回调
        handleClose(formName) {
            this.typeImgUrl = '';
            this.$refs[formName].resetFields();
            Object.assign(this.$data[formName], this.$options.data()[formName]);
        },
        // 编辑模块
        editModule(v) {
            if (this.permissions["Estate.Update"]) {
                switch (v) {
                    case "basic":
                        this.basicForm = deepCopy(this.estateBasic);
                        this.addressQuery = {
                            longitude: this.basicForm.longitude,
                            latitude: this.basicForm.latitude,
                            address: this.basicForm.synopsisAddress
                        };
                        let status;
                        switch (this.basicForm.saleStatus) {
                            case '预售':
                                status = 'PreSold'
                                break;
                            case '待开盘':
                                status = 'UnSold'
                                break;
                            case '在售':
                                status = 'Selling'
                                break;
                            case '售罄':
                                status = 'Sold'
                                break;
                        }
                        this.basicForm.saleStatus = status;
                        this.basicForm.locationAddress = '请输入';
                        if (this.basicForm.city) {
                            this.cityChange();
                        }
                        if (this.basicForm.district) {
                            areaSearchTree({
                                parentName: this.basicForm.district
                            }).then((res) => {
                                let arr = res.result.items;
                                this.streetOptions = [];
                                arr.map((el) => {
                                    this.streetOptions.push({
                                        name: el.data.name,
                                        id: el.data.id,
                                    });
                                });
                            });
                        }
                        if (this.basicForm.street) {
                            areaSearchTree({
                                parentName: this.basicForm.street
                            }).then((res) => {
                                let arr = res.result.items;
                                this.businessOptions = [];
                                arr.map((el) => {
                                    this.businessOptions.push({
                                        name: el.data.name,
                                        id: el.data.id,
                                    });
                                });
                            });
                        }
                        break;
                    case "salePoint":
                        this.salePointForm = deepCopy(this.salePoint);
                        this.checkedFeaturesChange(this.salePointForm.features);
                        break;
                    case "community":
                        this.communityForm = deepCopy(this.community);
                        break;
                    case "estateType":
                        this.estateTypeTitle = '添加户型';
                        break;
                    case "preSellCard":
                        this.preSellCardTitle = '添加预售证';
                        break;
                    case "counselors":
                        Object.assign(this.$data.counselorsForm, this.$options.data().counselorsForm);
                        break;
                }
                this.isEditInfo[v] = true;
            } else {
                this.$message.warning({
                    message: "您暂无管理楼盘权限",
                    showClose: true,
                });
            }
        },
        // 定位模块
        serviceItemChange(v) {
            //console.log(v);
            let el = document.querySelector(".main-container");
            switch (v.name) {
                case "基本信息":
                    el.scrollTop = 0;
                    break;
                case "项目人员":
                    el.scrollTop =
                        this.elTop.projectCounselors - this.elTop.serviceHeight;
                    break;
                case "楼盘卖点":
                    el.scrollTop = this.elTop.salePoint - this.elTop.serviceHeight;
                    break;
                case "小区信息":
                    el.scrollTop = this.elTop.community - this.elTop.serviceHeight;
                    break;
                case "周边信息":
                    el.scrollTop = this.elTop.estateMap - this.elTop.serviceHeight;
                    break;
                case "主力户型":
                    el.scrollTop = this.elTop.estateType - this.elTop.serviceHeight;
                    break;
                case "相册信息":
                    el.scrollTop = this.elTop.estatePhotos - this.elTop.serviceHeight;
                    break;
                case "VR信息":
                    el.scrollTop = this.elTop.estateVr - this.elTop.serviceHeight;
                    break;
                case "附件信息":
                    el.scrollTop = this.elTop.estateFile - this.elTop.serviceHeight;
                    break;
                case "预售证信息":
                    el.scrollTop = this.elTop.preSellCards - this.elTop.serviceHeight;
                    break;
            }
        },
        // 批量删除相册照片
        delBatchPhotos() {
            let len = this.photo.filter((el) => {
                return el.checked == true;
            }).length;
            this.$confirm(
                `您已选中了${len}张照片，确定删除选中的照片？`,
                `温馨提示`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }
            )
                .then(() => {
                    let data = [];
                    this.photo.map(el => {
                        if (el.checked) {
                            data.push("materialIds=" + el.id)
                        }
                    });
                    data = data.join("&");
                    this.deleteMaterials(this.estateId, data, 'photo');
                })
                .catch(() => {
                    //console.log("已取消");
                });
        },
        // 删除素材
        deleteMaterials(id, data, type) {
            deleteMaterials(id, data).then(res => {
                if (type == 'photo') {
                    this.getPhotos();
                } else if (type == 'vr') {
                    this.getVrMaterials();
                } else if (type == 'file') {
                    this.getFiles();
                }
                if (res) {
                    this.$message.success({
                        message: "删除成功",
                        showClose: true,
                    });
                }
            })
        },
        uploadFiles() {
            if (this.permissions['Estate.DownloadMaterials']) {
                this.isUploadFiles = true;
            } else {
                this.$message.warning({
                    message: "您暂无管理楼盘附件权限",
                    showClose: true,
                });
            }
        },
        // 批量删除附件
        delBatchFiles() {
            if (this.permissions['Estate.DownloadMaterials']) {
                let len = this.file.filter((el) => {
                    return el.checked == true;
                }).length;
                this.$confirm(
                    `您已选中了${len}个附件，确定删除选中的附件？`,
                    `温馨提示`, {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }
                )
                    .then(() => {
                        let data = [];
                        this.file.map(el => {
                            if (el.checked) {
                                data.push("materialIds=" + el.id)
                            }
                        });
                        data = data.join("&");
                        this.deleteMaterials(this.estateId, data, 'file');
                    })
                    .catch(() => {
                        //console.log("已取消");
                    });
            } else {
                this.$message.warning({
                    message: "您暂无管理楼盘附件权限",
                    showClose: true,
                });
            }
        },
        // 删除相册照片
        delPhotoItem(id) {
            this.$confirm(
                `确认删除该照片？`,
                `温馨提示`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }
            )
                .then(() => {
                    let data = [];
                    data.push("materialIds=" + id)
                    this.deleteMaterials(this.estateId, data, 'photo');
                })
                .catch(() => {
                    //console.log("已取消");
                });
        },
        delFileItem(id) {
            this.$confirm(
                `确认删除该附件？`,
                `温馨提示`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }
            )
                .then(() => {
                    let data = [];
                    data.push("materialIds=" + id)
                    this.deleteMaterials(this.estateId, data, 'file');
                })
                .catch(() => {
                    //console.log("已取消");
                });
        },
        // 上传相册弹窗关闭回调
        uploadPhotosClose() {
            this.uploadPhotoList = [];
            this.checkAllPhoto = false;
        },
        // 上传附件弹窗关闭回调
        uploadFilesClose() {
            this.uploadFileList = [];
            this.checkAllFile = false;
        },
        // 弹窗批量选择分类
        batchSetSelect(v) {
            this.batchSetText = "选择分类";
            this.uploadPhotoList.map((el) => {
                if (el.checked) {
                    el.type = v;
                }
            });
        },
        // 弹窗批量选择分类
        fileBatchSetSelect(v) {
            this.batchSetText = "选择分类";
            this.uploadFileList.map((el) => {
                if (el.checked) {
                    el.type = v;
                }
            });
        },
        // 删除相册
        delPhotoItme(index) {
            this.uploadPhotoList.splice(index, 1);
            if (res) {
                this.$message.success({
                    message: "删除成功",
                    showClose: true,
                });
            }
        },
        // 删除附件
        delFileItme(index) {
            this.uploadFileList.splice(index, 1);
        },
        // 上传相册弹窗选择框回调
        checkPhotoItem(v) {
            if (v) {
                this.checkAllPhoto = this.uploadPhotoList.every((el) => {
                    return el.checked == true;
                });
            } else {
                this.checkAllPhoto = false;
            }
        },
        // 上传附件弹窗选择框回调
        checkFileItem(v) {
            if (v) {
                this.checkAllFile = this.uploadFileList.every((el) => {
                    return el.checked == true;
                });
            } else {
                this.checkAllFile = false;
            }
        },
        // 上传相册弹窗全选回调
        checkAllPhotoChange(val) {
            this.uploadPhotoList.map((el) => {
                el.checked = val;
            });
        },
        // 上传附件弹窗全选回调
        checkAllFileChange(val) {
            this.uploadFileList.map((el) => {
                el.checked = val;
            });
        },
        // 上传相册钩子
        uploadPhotosChange(file) {
            if (file.size>5*1024*1024) {
                this.$message.warning({
                    message: `${file.name}图片超过5M，不能上传`,
                    showClose: true,
                });
                return
            }else{
                this.uploadPhotoList.push({
                    file: file.raw,
                    url: URL.createObjectURL(file.raw),
                    checked: false,
                    type: '',
                    error: false,
                })
            }
        },
        // 上传附件钩子
        uploadFilesChange(file) {
            let fileExt = file.name.split('.');
            fileExt = fileExt[fileExt.length - 1];
            let fileType = '';
            if (["jpg", "png", "jpeg"].indexOf(fileExt.toLowerCase()) > -1) {
                fileType = 'image';
            } else if (["mp4", "m3u8"].indexOf(fileExt.toLowerCase()) > -1) {
                fileType = 'video';
            } else if (["pdf", "doc", "docx", "xlsx"].indexOf(fileExt.toLowerCase()) > -1) {
                fileType = 'document';
            } else if (["txt", "rmvb", "rm", "3gp", "mov", "m4v", "wmv", "avi", "dat", "mkv", "flv", "vob", "asf", "asx"].indexOf(fileExt.toLowerCase()) > -1) {
                return
            } else {
                fileType = 'other';
            }
            this.uploadFileList.push({
                fileName: file.name,
                file: file.raw,
                url: URL.createObjectURL(file.raw),
                checked: false,
                type: '',
                error: false,
                fileType,
            })
        },
        // 设置封面
        setCover(id) {
            updateCover(this.estateId, id).then(res => {
                this.getPhotos();
                if (res) {
                    this.$message.success({
                        message: "设置成功",
                        showClose: true,
                    });
                }
            })
        },
        // 提交上传相册回调
        submitUploadPhotos() {
            let status = true;
            let arr = [];
            this.uploadPhotoList.map(el => {
                el.checked = false;
                if (!el.type) {
                    status = false;
                    el.error = true;
                } else {
                    el.error = false;
                }
                arr.push({
                    file: el.file,
                    type: el.type
                });
            })
            if (status) {
                this.isLoading = true;
                let formData = new FormData();
                formData.append("SourceType", 'Photo');
                arr.map((el, i) => {
                    formData.append(`Materials[${i}].File`, el.file);
                    formData.append(`Materials[${i}].Type`, el.type);
                })
                uploadPhotoMaterials(this.estateId, formData).then(res => {
                    this.getPhotos();
                    if (res) {
                        this.$message.success({
                            message: "上传成功",
                            showClose: true,
                        });
                    }
                    this.isUploadPhotos = false;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            } else {
                //console.log('表单未通过');
            }
        },
        // 提交附件表单
        submitUploadFiles() {
            let status = true;
            let arr = [];
            this.uploadFileList.map(el => {
                el.checked = false;
                if (!el.type) {
                    status = false;
                    el.error = true;
                } else {
                    el.error = false;
                }
                arr.push({
                    file: el.file,
                    type: el.type
                });
            })
            if (status) {
                this.isLoading = true;
                let formData = new FormData();
                formData.append("SourceType", 'Accessory');
                arr.map((el, i) => {
                    formData.append(`Materials[${i}].File`, el.file);
                    formData.append(`Materials[${i}].Type`, el.type);
                })
                uploadMaterials(this.estateId, formData).then(res => {
                    this.getFiles();
                    if (res) {
                        this.$message.success({
                            message: "上传成功",
                            showClose: true,
                        });
                    }
                    this.isUploadFiles = false;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            } else {
                //console.log('表单未通过');
            }
        },
        //关闭视频弹窗
        closeVideo() {
            this.videoUrl = "";
        },
        // 初始化数据
        initData() {
            this.permissions = this.$store.getters.permissions;
            this.getBasicInfo();
            this.getCounselors();
            this.getSalepoint();
            this.getCommunity();
            this.getHousetypes();
            this.getPresellcards();
            this.getPhotos();
            this.getVrMaterials();
            if (this.permissions['Estate.LookMaterials']) {
                this.getFiles();
            }
            this.areasSearch();
            this.interval = setInterval(() => {
                this.initScroll()
            }, 100)
        },
        initTabActiveLine() {
            document.querySelector(".traffic-tab .el-tabs__active-bar").style.width = "42px";
            let el=document.querySelector(".photo-tab .el-tabs__item.isactive");
            if (el) {
                document.querySelector(".photo-tab .el-tabs__active-bar").style.width = document.querySelector(".photo-tab .el-tabs__item.isactive").offsetWidth - 60 + 'px';
            }else{
                document.querySelector(".photo-tab .el-tabs__active-bar").style.width="60px";
            }
            if (this.permissions['Estate.LookMaterials']&&el) {
                document.querySelector(".file-tab .el-tabs__active-bar").style.width = document.querySelector(".file-tab .el-tabs__item.isactive").offsetWidth - 60 + 'px';
            }else{
                document.querySelector(".file-tab .el-tabs__active-bar").style.width = "60px";
            }
            document.querySelector(".vr-tab .el-tabs__active-bar").style.width = "28px";
        },
        initScroll() {
            if (this.elTop.preSellCards != 0) {
                clearInterval(this.interval); //停止
            }
            try {
                if (!this.permissions['Estate.LookMaterials']) {
                    this.isInit.accessory = true
                }

                if (this.isInit.community && this.isInit.salePoint && this.isInit.counselors && this.isInit.estateBasic && this.isInit.housetypes && this.isInit.presellcards && this.isInit.photo && this.isInit.vr && this.isInit.accessory) {
                    this.initTabActiveLine();
                    let el = document.querySelector(".main-container");
                    el.addEventListener("scroll", this.scrollScreen);
                    this.elTop.serviceHeight = this.$refs.serviceItems.offsetHeight;
                    this.elTop.serviceItems = this.$refs.serviceItems.getBoundingClientRect().top;
                    this.elTop.estateBasic =
                        this.$refs.estateBasic.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.projectCounselors =
                        this.$refs.projectCounselors.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.salePoint =
                        this.$refs.salePoint.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.community =
                        this.$refs.community.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.estateMap =
                        this.$refs.estateMap.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.estateType =
                        this.$refs.estateType.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.estatePhotos =
                        this.$refs.estatePhotos.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.elTop.estateVr =
                        this.$refs.estateVr.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    if (this.permissions['Estate.LookMaterials']) {
                        this.elTop.estateFile =
                            this.$refs.estateFile.getBoundingClientRect().top -
                            this.elTop.serviceHeight;
                    }
                    this.elTop.preSellCards =
                        this.$refs.preSellCards.getBoundingClientRect().top -
                        this.elTop.serviceHeight;
                    this.isInit.isInit = false;
                }
            } catch (error) {
                //console.log(error,'error');
                this.isInit.isInit = false;
                clearInterval(this.interval); //停止
            }
        },
        // 头部滚动样式
        scrollScreen() {
            let top =
                document.querySelector(".main-container").scrollTop +
                this.elTop.serviceHeight;
            if (top < this.elTop.projectCounselors) {
                this.serviceActive("基本信息");
            } else if (
                top >= this.elTop.projectCounselors &&
                top < this.elTop.salePoint
            ) {
                this.serviceActive("项目人员");
            } else if (top >= this.elTop.salePoint && top < this.elTop.community) {
                this.serviceActive("楼盘卖点");
            } else if (top >= this.elTop.community && top < this.elTop.estateMap) {
                this.serviceActive("小区信息");
            } else if (top >= this.elTop.estateMap && top < this.elTop.estateType) {
                this.serviceActive("周边信息");
            } else if (top >= this.elTop.estateType && top < this.elTop.estatePhotos) {
                this.serviceActive("主力户型");
            } else if (top >= this.elTop.estatePhotos && top < this.elTop.estateVr) {
                this.serviceActive("相册信息");
            } else if (top >= this.elTop.estateVr && top < this.elTop.estateFile) {
                this.serviceActive("VR信息");
            } else if (top >= this.elTop.preSellCards) {
                this.serviceActive("预售证信息");
            } else if (top >= this.elTop.estateFile && top < this.elTop.preSellCards && this.permissions['Estate.LookMaterials']) {
                this.serviceActive("附件信息");
            }

            if (top > this.elTop.serviceItems) {
                this.isTopVisible = true;
            } else {
                this.isTopVisible = false;
            }
        },
        // 激活头部项目
        serviceActive(v) {
            this.serviceItems.map((el) => {
                if (el.name == v) {
                    el.isActive = true;
                } else {
                    el.isActive = false;
                }
            });
        },
        // 页面滚动
        roll(v) {
            let el = document.querySelector(".main-container");
            el.scrollTop = v;
        },
        // 下载附件
        download(fileName) {
            downloadMterial(this.estateId, {
                fileName
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            })
        },
        //下载楼盘相册
        downloadphoto(fileName) {
            downloadPhotoMterial(this.estateId, {
                fileName
            }).then(res => {
                //console.log(res, '下载回调');
                const content = res;
                const blob = new Blob([content]);
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            })
        },
        checkItem(v, type) {
            if (type == 'photo') {
                if (v) {
                    this.photosAllChecked = this.photo.every((el) => {
                        return el.checked == true;
                    });
                } else {
                    this.photosAllChecked = false;
                }
            } else {
                if (v) {
                    this.filesAllChecked = this.file.every((el) => {
                        return el.checked == true;
                    });
                } else {
                    this.filesAllChecked = false;
                }
            }
            this.$forceUpdate()
        },
        checkVrItem(v) {
            if (v) {
                this.vrAllChecked = this.vr.every((el) => {
                    return el.checked == true;
                });
            } else {
                this.vrAllChecked = false;
            }
            this.$forceUpdate()
        },
        checkAllPhotos(v) {
            this.photo.map((el) => {
                el.checked = v;
            });
            //console.log(this.photo, 'this.photo');
        },
        checkAllVrs(v) {
            this.vr.map((el) => {
                el.checked = v;
            });
        },
        checkAllFiles(v) {
            this.file.map((el) => {
                el.checked = v;
            });
        },
        // 相册批量修改类别回调
        photosSelect(v) {
            let arr = this.photo.filter((el) => {
                return el.checked == true;
            });
            if (arr.length == 1 && arr[0].type == v) {
                this.photoSelectText = "批量修改类别";
            } else {
                this.$confirm(
                    `您已选中了${arr.length}张照片，确定将选中的照片类别修改为${v}？`,
                    `温馨提示`, {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }
                )
                    .then(() => {
                        let data = [];
                        this.photo.map(el => {
                            if (el.checked) {
                                data.push({
                                    id: el.id,
                                    type: v
                                });
                            }
                        });
                        updateMaterialsType(this.estateId, data).then(res => {
                            this.getPhotos();
                            this.photoSelectText = "批量修改类别";
                            if (res) {
                                this.$message.success({
                                    message: "修改成功",
                                    showClose: true,
                                });
                            }
                        })
                    })
                    .catch(() => {
                        //console.log("已取消");
                        this.photoSelectText = "批量修改类别";
                    });
            }
        },
        filesSelect(v) {
            let arr = this.file.filter((el) => {
                return el.checked == true;
            });
            if (arr.length == 1 && arr[0].type == v) {
                this.photoSelectText = "批量修改类别";
            } else {
                this.$confirm(
                    `您已选中了${arr.length}条附件，确定将选中的附件类别修改为${v}？`,
                    `温馨提示`, {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }
                )
                    .then(() => {
                        let data = [];
                        this.file.map(el => {
                            if (el.checked) {
                                data.push({
                                    id: el.id,
                                    type: v
                                });
                            }
                        });
                        updateMaterialsType(this.estateId, data).then(res => {
                            this.getFiles();
                            this.photoSelectText = "批量修改类别";
                            if (res) {
                                this.$message.success({
                                    message: "修改成功",
                                    showClose: true,
                                });
                            }
                        })
                    })
                    .catch(() => {
                        //console.log("已取消");
                        this.photoSelectText = "批量修改类别";
                    });
            }
        },
        handlerMap({BMap,map}){
            var point = new BMap.Point(this.center.lng, this.center.lat)
            this.zoom = 15;
            map.centerAndZoom(point, 15)
            setTimeout(() => {
                this.keyword = "公交站";
                map.panTo(point)
            }, 1000);
        },
        // 切换地图tab
        switchMapTab(v) {
            //console.log(v);
            let name = v.label;
            switch (name) {
                case "交通":
                    name = "公交站";
                    break;

                case "教育":
                    name = "幼儿园";
                    if (this.activeEducation == "幼儿园") {
                        document.querySelector(
                            ".education-tab .el-tabs__active-bar"
                        ).style.width = "42px";
                    }
                    break;

                case "医疗":
                    name = "医院";
                    if (this.activeMedical == "医院") {
                        document.querySelector(
                            ".medical-tab .el-tabs__active-bar"
                        ).style.width = "28px";
                    }
                    break;

                case "购物":
                    name = "商场";
                    if (this.activeShop == "商场") {
                        document.querySelector(
                            ".shop-tab .el-tabs__active-bar"
                        ).style.width = "28px";
                    }
                    break;

                case "生活":
                    name = "银行";
                    if (this.activeLive == "银行") {
                        document.querySelector(
                            ".live-tab .el-tabs__active-bar"
                        ).style.width = "28px";
                    }
                    break;

                case "娱乐":
                    name = "公园";
                    if (this.activeRecreation == "公园") {
                        document.querySelector(
                            ".recreation-tab .el-tabs__active-bar"
                        ).style.width = "28px";
                    }
                    break;
            }
            this.keyword = name;
        },
        // 切换相册tab
        switchPhotos(v) {
            this.getPhotoItem(v.name);
        },
        // 切换Vr
        switchVr(v) {
            this.getVrItem(v.name);
        },
        switchFiles(v) {
            this.getFileItem(v.name)
        },
        getSrcList(index) {
            let arr = [];
            if (this.photo.length) {
                this.photo.map(el => {
                    arr.push(el.url);
                })
                return arr.slice(index).concat(arr.slice(0, index));
            }
        },
        // 复制VR链接
        copyVrUrl() {
            this.$message.success({
                message: "复制成功",
                showClose: true,
            });
        },
        // 删除VR
        delVrItem(id) {
            this.$confirm(
                `确认删除该VR？`,
                `温馨提示`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }
            )
                .then(() => {
                    let data = [];
                    data.push("materialIds=" + id)
                    this.deleteMaterials(this.estateId, data, 'vr');
                })
                .catch(() => {
                    //console.log("已取消");
                });
        },
        submitVr() {
            this.$refs["vrForm"].validate((valid) => {
                if (valid) {
                    let data = deepCopy(this.vrForm);
                    this.isLoading = true;
                    if (data.type != '其他') {
                        let arr = data.type.split('#$%&@');
                        data.sourceId = arr[1];
                        data.type = arr[0];
                        data.enableClearThisType = true;
                    } else {
                        data.type = '其他'
                    }
                    uploadVr(this.estateId, data).then(res => {
                        this.getVrMaterials();
                        this.isEditInfo.isCreateVr = false;
                        this.isLoading = false;
                    }).catch(() => {
                        this.isLoading = false;
                    })
                } else {
                    //console.log("表单验证未通过");
                    return false;
                }
            });
        },
        // 批量删除vr
        delBatchVrs() {
            let len = this.vr.filter((el) => {
                return el.checked == true;
            }).length;
            this.$confirm(
                `您已选中了${len}条VR，确定删除选中的VR？`,
                `温馨提示`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }
            )
                .then(() => {
                    let data = [];
                    this.vr.map(el => {
                        if (el.checked) {
                            data.push("materialIds=" + el.id)
                        }
                    });
                    data = data.join("&");
                    this.deleteMaterials(this.estateId, data, 'vr');
                })
                .catch(() => {
                    //console.log("已取消");
                });
        },
    },
};